import { useState, useEffect } from 'react';
import { ProductRegisterPage } from './seller/ProductRegisterPage';
import { DesktopProductRegisterPage } from './desktop/DesktopProductRegisterPage';

export function ResponsiveProductRegisterPage() {
  const [isMobile, setIsMobile] = useState(true);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return isMobile ? <ProductRegisterPage /> : <DesktopProductRegisterPage />;
}